import {
  BOOKING_GET_LIST_DELTA,
  BOOKING_GET_LIST_DELTA_SUCCESS,
  BOOKING_GET_LIST_DELTA_ERROR,
  BOOKING_GET_LIST_WITH_FILTER,
  BOOKING_GET_LIST_WITH_ORDER,
  BOOKING_GET_LIST_SEARCH,
  BOOKING_ADD_ITEM,
  BOOKING_CREATE_ITEM,
  BOOKING_ADD_ITEM_SUCCESS,
  BOOKING_CREATE_ITEM_SUCCESS,
  BOOKING_ADD_ITEM_ERROR,
  BOOKING_CREATE_ITEM_ERROR,
  BOOKING_INVOKE_KEY,
  BOOKING_INVOKE_KEY_SUCCESS,
  BOOKING_INVOKE_KEY_ERROR,
  BOOKING_ADD_ITEM_BEFORE_API_REQUEST_SUCCESS,
  CHANGE_LANGUAGE_FOR_BOOKING_ITEMS,
  BOOKING_SHOW_TOAST_SET,
  EASEE_GET_ADMIN_USERS,
  EASEE_GET_ADMIN_USERS_SUCCESS,
  EASEE_GET_ADMIN_USERS_ERROR
} from "../actions";

export const getBookingListDelta = fetchMore => ({
  type: BOOKING_GET_LIST_DELTA,
  payload: fetchMore
});
export const getBookingListDeltaSuccess = (items, allLoaded) => ({
  type: BOOKING_GET_LIST_DELTA_SUCCESS,
  payload: { items, allLoaded }
});

export const getBookingListDeltaError = error => ({
  type: BOOKING_GET_LIST_DELTA_ERROR,
  payload: error
});

export const getBookingListWithFilter = (column, value) => ({
  type: BOOKING_GET_LIST_WITH_FILTER,
  payload: { column, value }
});

export const getBookingListWithOrder = (column, direction = "asc") => ({
  type: BOOKING_GET_LIST_WITH_ORDER,
  payload: { column, direction }
});

export const getBookingListSearch = keyword => ({
  type: BOOKING_GET_LIST_SEARCH,
  payload: keyword
});

export const addBookingItem = item => ({
  type: BOOKING_ADD_ITEM,
  payload: item
});

export const addBookingItemSuccess = item => ({
  type: BOOKING_ADD_ITEM_SUCCESS,
  payload: item
});

export const addBookingItemBeforeApiRequestSuccess = item => ({
  type: BOOKING_ADD_ITEM_BEFORE_API_REQUEST_SUCCESS,
  payload: item
});

export const addBookingItemError = snapshotAndError => ({
  type: BOOKING_ADD_ITEM_ERROR,
  payload: snapshotAndError
});

export const invokeBookingKeylessKey = items => ({
  type: BOOKING_INVOKE_KEY,
  payload: items
});

export const invokeBookingKeylessKeySuccess = items => ({
  type: BOOKING_INVOKE_KEY_SUCCESS,
  payload: items
});

export const invokeBookingKeylessKeyError = error => ({
  type: BOOKING_INVOKE_KEY_ERROR,
  payload: error
});

export const changeLanguageForBookingItems = payload => ({
  type: CHANGE_LANGUAGE_FOR_BOOKING_ITEMS,
  payload
});

export const setBookingShowToast = visible => ({
  type: BOOKING_SHOW_TOAST_SET,
  payload: visible
});

export const createBookingItem = item => ({
  type: BOOKING_CREATE_ITEM,
  payload: item
});

export const createBookingItemSuccess = item => ({
  type: BOOKING_CREATE_ITEM_SUCCESS,
  payload: item
});

export const createBookingItemError = snapshotAndError => ({
  type: BOOKING_CREATE_ITEM_ERROR,
  payload: snapshotAndError
});

export const easeeGetAdminUsers = () => ({
  type: EASEE_GET_ADMIN_USERS
});

export const easeeGetAdminUsersSuccess = items => ({
  type: EASEE_GET_ADMIN_USERS_SUCCESS,
  payload: items
});

export const easeeGetAdminUsersError = error => ({
  type: EASEE_GET_ADMIN_USERS_ERROR,
  payload: error
});
